/* Sport Sun — offer price row
 *
 * Keeps .ss-offer-price in sync when the shopper switches variant.
 *
 * The theme's own <hdt-price> element listens for "variant:change" on the product form and
 * rewrites itself with the raw variant price. The offer row is deliberately NOT built on that
 * element — a computed price would be overwritten on every switch — so it listens to the same
 * event and swaps in strings that ss-offer-price.liquid pre-formatted for each variant.
 */
(function () {
  'use strict';

  var EVENT = 'variant:change';

  function readMap(formId) {
    var el = document.querySelector('[data-ss-offer-map="' + (window.CSS && CSS.escape ? CSS.escape(formId) : formId) + '"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // The sticky bar lives in layout/theme.liquid, outside the product section, so it cannot know
  // the form's generated id. Resolve the real add-to-cart form, ignoring the sticky bar's own.
  function findProductForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].id && forms[i].id.indexOf('form-product-sticky') === 0) continue;
      if (forms[i].id) return forms[i];
    }
    return null;
  }

  function bind(row) {
    if (row.dataset.ssBound) return;

    var form;
    var mapKey;

    if (row.hasAttribute('data-ss-form-auto')) {
      form = findProductForm();
      mapKey = 'ss-auto';
    } else {
      mapKey = row.getAttribute('data-ss-form');
      if (!mapKey) return;
      form = document.forms[mapKey];
    }

    if (!form) return;

    var map = readMap(mapKey);
    if (!map) return;

    row.dataset.ssBound = '1';

    var now = row.querySelector('[data-ss-now]');
    var was = row.querySelector('[data-ss-was]');

    form.addEventListener(EVENT, function (event) {
      var variant = event && event.detail && event.detail.variant;
      if (!variant) return;

      var entry = map[String(variant.id)];
      if (!entry) return;

      if (now) now.textContent = entry.now;
      if (was) was.textContent = entry.was;
    });
  }

  function init() {
    var rows = document.querySelectorAll('[data-ss-offer-price][data-ss-form], [data-ss-offer-price][data-ss-form-auto]');
    for (var i = 0; i < rows.length; i++) bind(rows[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Quick view and quick add inject their markup after load.
  document.addEventListener('lazyhtml:added', init);
})();
